import { driverAvailabilityHistoryQuerySchema, type DriverAvailabilityHistoryEntry, type Page } from '@chukua/common';
import { useEffect, useState } from 'react';
import { useListQuery } from '../../../shared/hooks/use-list-query';
import { listDriverAvailabilityHistory } from '../drivers.api';

export type AvailabilityHistoryState = { status: 'loading' } | { status: 'loaded'; page: Page<DriverAvailabilityHistoryEntry> } | { status: 'error' };

/** The page of a driver's availability changes the URL's list query asks for. */
export function useAvailabilityHistory(driverId: string) {
  const list = useListQuery(driverAvailabilityHistoryQuerySchema);
  const { query } = list;
  const [state, setState] = useState<AvailabilityHistoryState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    listDriverAvailabilityHistory(driverId, query)
      .then((page) => {
        if (!cancelled) setState({ status: 'loaded', page });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });
    return () => {
      cancelled = true;
    };
  }, [driverId, query]);

  return { state, list };
}
